import { InstitutionalPage } from '@/components/institutional-page'

export function FaqPage() {
  return InstitutionalPage({
    title: 'FAQ & Documentation - ResumeHeaders',
    heading: 'FAQ & Documentation',
    markdownUrl: '/content/faq.md',
    background: 'white',
    showHeader: true,
    showFooter: true,
  })
}
